import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Table and Button from Ant Design
import { Api_Url } from "../../../../config/config";
import axios from "axios";

const AutoDriverDetails = ({ allData }) => {
  console.log(allData)
  const [data, setData] = useState([]);
  const [rowLimit, setRowLimit] = useState(3);

  useEffect(() => {
    // Set data only if allData changes
    setData(allData);
  }, [allData]);

  console.log(data);

  const columns = [
    {
      title: "Registration Number",
      dataIndex: "registrationNumber",
      key: "name",
    },
    {
      title: "Age Of Auto",
      dataIndex: "ageOfAuto",
      key: "amount",
    },
    {
      title: "Distance In Month",
      dataIndex: "distanceInMonth",
    },
    {
      title: "Distance In One Trip",
      dataIndex: "distanceInOneTrip",
    },
    {
      title: "Life Of Auto",
      dataIndex: "lifeOfAuto",
    },
    {
      title: "Monthly Depreciation",
      dataIndex: "monthlyDepreciation",
    },
    {
      title: "Monthly Income",
      dataIndex: "monthlyIncome",
    },
    {
      title: "Rent",
      dataIndex: "rent",
    },
    {
      title: "Total Distance",
      dataIndex: "totalDistance",
    },
    {
      title: "Total Trip",
      dataIndex: "totalTrip",
    },
    {
      title: "Trip Charges",
      dataIndex: "tripCharges",
    },
    {
      title: "Purchase Cost",
      dataIndex: "purchaseCost",
    },
  ];

  // const handleViewAll = () => {
  //   setRowLimit(rowLimit === 3 ? data.length : 3);
  // };

  return (
    <div className="container">
      <div className="row">
        {data && data.length > 0 ? (
          <div className="col-12">
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  // dataSource={data.slice(0, rowLimit)}
                  dataSource={data}
                  columns={columns}
                  pagination={false}
                  rowKey={(record) => record.id}
                />
                {/* {data.length > 3 && (
                  <Button
                    onClick={handleViewAll}
                    block
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    {rowLimit === 3 ? "View All" : "Show Less"}
                  </Button>
                )} */}
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutoDriverDetails;
